import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'

import { ReservationCalendars } from '../ReservationCalendars'
import { useModuleConfig } from '../../hooks/useModuleConfig/useModuleConfig'
import { ReservationsList } from '../../components/ReservationsList'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

import {
  SidebarInfoSection,
  SidebarInfoSectionText,
  ReservationRulesAndTermsLinks,
  View,
} from 'components'

export const CommonAreaReservations: React.FC = () => {
  const { t } = useTranslation(['common', 'reservations', 'titles'])
  const moduleConfig = useModuleConfig()
  const { frontPagePath } = useContractPaths()
  const { currentContractId } = useCurrentContract()

  const moduleLinks: { href: string; label: string }[] = []
  const commonAreaConfig = moduleConfig.commonAreaReservations
  if (commonAreaConfig?.contractDocumentLink) {
    moduleLinks.push({
      href: commonAreaConfig.contractDocumentLink,
      label: t('reservations:modal.commonAreaRulesLink'),
    })
  }
  if (commonAreaConfig?.termsOfUseDocumentLink) {
    moduleLinks.push({
      href: commonAreaConfig.termsOfUseDocumentLink,
      label: t('reservations:modal.commonAreaTermsLink'),
    })
  }

  return (
    <TitleController title={t('titles:commonAreaReservations')}>
      <View allowOverflow>
        <View.Header className="desktop:h-80">
          <View.HeaderLink to={frontPagePath}>
            {t('common:views.home')}
          </View.HeaderLink>
          <View.HeaderTitle className="phone:text-common-gray-7">
            {t('reservations:pageTitleCommonAreas')}
          </View.HeaderTitle>
        </View.Header>

        <View.Sidebar>
          <SidebarInfoSection className="space-y-4">
            <SidebarInfoSectionText>
              {t('reservations:commonAreaSidebarDescription')}
            </SidebarInfoSectionText>
            <ReservationRulesAndTermsLinks
              contractId={currentContractId}
              reservableCategory="reservable_common_area"
              realPropertyHierarchyId={null}
              fallbackLinks={moduleLinks}
            />
            <ReservationsList reservableCategory="reservable_common_area" />
          </SidebarInfoSection>
        </View.Sidebar>

        <View.Content>
          <ReservationCalendars reservableCategory="reservable_common_area" />
        </View.Content>
      </View>
    </TitleController>
  )
}
